import React, { useEffect, useRef } from "react";

const btn = (actief) => ({
  fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase",
  padding: "8px 11px", border: "1px solid var(--line)", background: "transparent",
  color: actief ? "var(--ink)" : "var(--gold)", cursor: "pointer",
  transition: "background .2s var(--ease), color .2s var(--ease)",
});

const veldStijl = {
  width: "100%", minHeight: 52, padding: "13px 15px",
  background: "rgba(243,234,215,0.04)", border: "1px solid var(--line)",
  fontFamily: "var(--serif)", fontSize: 17, lineHeight: 1.6, color: "var(--cream)",
  outline: "none",
};

function Toolbar({ acties, testId }) {
  return (
    <div data-testid={testId} style={{ display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" }}>
      {acties.map(([label, fn, tid]) => (
        <button key={label} type="button" data-testid={tid} onMouseDown={(e) => e.preventDefault()}
          onClick={fn} style={btn(false)}
          onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(201,169,97,0.12)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
        >{label}</button>
      ))}
    </div>
  );
}

function useEditable(waarde, onChange, meerregelig) {
  const ref = useRef(null);
  const eigen = useRef(false);
  useEffect(() => {
    if (!ref.current) return;
    if (eigen.current) { eigen.current = false; return; }
    if (ref.current.innerHTML !== (waarde || "")) ref.current.innerHTML = waarde || "";
  }, [waarde]);
  const meld = () => {
    eigen.current = true;
    onChange(ref.current.innerHTML);
  };
  const onKeyDown = (e) => {
    if (!meerregelig && e.key === "Enter") e.preventDefault();
  };
  return { ref, meld, onKeyDown };
}

function cmd(ref, naam, waarde) {
  ref.current?.focus();
  document.execCommand(naam, false, waarde);
}

export function InlineEditor({ waarde, onChange, testId }) {
  const { ref, meld, onKeyDown } = useEditable(waarde, onChange, false);
  return (
    <div>
      <Toolbar testId={`${testId}-toolbar`} acties={[
        ["Vet", () => cmd(ref, "bold"), `${testId}-vet`],
        ["Cursief", () => cmd(ref, "italic"), `${testId}-cursief`],
      ]} />
      <div ref={ref} contentEditable suppressContentEditableWarning data-testid={testId}
        onInput={meld} onBlur={meld} onKeyDown={onKeyDown} role="textbox"
        style={{ ...veldStijl, minHeight: 52, whiteSpace: "pre-wrap" }} />
    </div>
  );
}

export function RichEditor({ waarde, onChange, testId }) {
  const { ref, meld } = useEditable(waarde, onChange, true);
  const link = () => {
    const url = window.prompt("Naar welke link?", "https://");
    if (url) cmd(ref, "createLink", url);
  };
  return (
    <div>
      <Toolbar testId={`${testId}-toolbar`} acties={[
        ["Vet", () => cmd(ref, "bold"), `${testId}-vet`],
        ["Cursief", () => cmd(ref, "italic"), `${testId}-cursief`],
        ["Tussenkop", () => cmd(ref, "formatBlock", "h3"), `${testId}-tussenkop`],
        ["Alinea", () => cmd(ref, "formatBlock", "p"), `${testId}-alinea`],
        ["Opsomming", () => cmd(ref, "insertUnorderedList"), `${testId}-opsomming`],
        ["Link", link, `${testId}-link`],
      ]} />
      <div ref={ref} contentEditable suppressContentEditableWarning data-testid={testId}
        onInput={meld} onBlur={meld} role="textbox"
        className="rich-editor"
        style={{ ...veldStijl, minHeight: 220, overflowY: "auto", maxHeight: 460 }} />
    </div>
  );
}

export { veldStijl };
